/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&name=Gen&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=Gen&lang=js"

const __exports__ = script;

export default __exports__